export default __webpack_public_path__ + "static/media/face.78d34fe5.jpg";